import React, { type FC } from 'react';

import { FormattedMessage } from 'react-intl';

import DropZone from '@components-legacy/DropZone';
import Modal from '@components/Modal';

import { type DragDropModalProps } from './types';

/** Modal for uploading files */
const DragDropModal: FC<DragDropModalProps> = ({
  acceptedList,
  children,
  'data-testid': dataTestId = 'DragDropModal',
  onUploadComplete,
  title = <FormattedMessage defaultMessage="Upload file" id="components.drag-drop-modal.title" />,
  ...ModalProps
}) => (
  <Modal dividers data-testid={dataTestId} title={title} {...ModalProps}>
    <DropZone acceptedList={acceptedList} onDropComplete={onUploadComplete} />
    {children}
  </Modal>
);

export default DragDropModal;
